import { useEffect, useRef, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { DataItem } from 'src/types/DataItem';

import { toArray } from 'src/utils/helpers';

import { Button } from 'src/components/basicContent/_Button/Button';
import { Pill } from 'src/components/basicContent/_Pill/Pill';

import ChevronDownIconSvg from 'public/icons/ChevronDown.svg';

import styles from './_SearchFilter.module.css';

type SearchFilterProps = {
	inputData: {
		name: string;
		placeholder: string;
		data: DataItem[];
	};
	learningTopics?: string;
};

export function SearchFilter(props: SearchFilterProps): JSX.Element {
	const { getValues, setValue } = useFormContext();
	const headBtn = useRef<HTMLButtonElement>(null);
	const selectedValues = toArray(getValues(props.inputData.name));

	const [active, setActive] = useState(false);

	useEffect(() => {
		if (props.learningTopics?.trim() !== '') {
			setOptionValue(props.inputData.name, props.inputData.data.filter((d) => d.value === props.learningTopics)[0]?.value);
		}
	}, [props.learningTopics]);

	const setOptionValue = (name: string, value: number | string) => {
		if (selectedValues.includes(`${value}`)) {
			setValue(
				name,
				selectedValues.filter((x: unknown) => x !== value)
			);
		} else {
			setValue(
				name,
				[value, ...selectedValues].filter((x) => x)
			);
		}
		setActive(false);
	};

	const activeClass = active ? styles.active : '';

	return (
		<div className={styles.filterColumn}>
			<div className={styles.searchFilterContainer}>
				<div
					className={`${styles.root} ${activeClass}`}
					tabIndex={0}
					onBlur={(e) => {
						if (!e.currentTarget.contains(e.relatedTarget)) {
							setActive(false);
						}
					}}
				>
					<Button
						title="selectSearch"
						buttonRef={headBtn}
						className={`${styles.head} ${activeClass}`}
						onClick={(e) => {
							if (e?.nativeEvent.target === headBtn.current) {
								setActive(!active);
							}
						}}
					>
						<>{props.inputData.placeholder}</>
						<ChevronDownIconSvg className={`${styles.icon} ${activeClass}`} />
					</Button>

					<div className={`${styles.searchByFilterBody} ${activeClass}`}>
						<span className={styles.list + ' white rounded'}>
							{props.inputData.data.map((item, index) => {
								return (
									<Button
										key={`${styles.root}-${index}`}
										title="selectSearchOption"
										className={`${selectedValues.some((x) => x === item.value) ? styles.selected : ''} ${
											styles.selectSearchOption
										} buttonReset`}
										onClick={() => setOptionValue(props.inputData.name, item.value)}
									>
										<>
											<span className={styles.checkBox} />
											{item.label}
										</>
									</Button>
								);
							})}
						</span>
					</div>
				</div>
			</div>

			{selectedValues.length > 0 && (
				<div className={styles.pillColumn}>
					{selectedValues.map((id: string, index: number) => {
						return <Pill option={id} filterName={props.inputData.name} key={props.inputData.name + index} />;
					})}
				</div>
			)}
		</div>
	);
}
